<div class="flex items-center gap-2"
     [class.origami-updated]="isUpdatedByOrigami"
>
  @if (control(); as ctrl) {
    <p-checkbox [binary]="true"
                [formControl]="ctrl"
                [inputId]="inputId()"
    />
  }
  <label class="font-medium cursor-pointer"
         [for]="inputId()"
  >{{ label() }}</label>
</div>
